import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { GridDeleteIcon } from "@mui/x-data-grid";
import { Add } from "@mui/icons-material";
import useStyles from "../styles";
import React from "react";

interface Metric {
  key: string;
  type: string;
  label: string;
}

interface MetricsCardProps {
  metricsValue: boolean;
  setMetricsValue: (value: boolean) => void;
  metricsContent: Metric[];
  handleAddMetrics: () => void;
  handleMetricKeyChange: (e: any, index: number) => void;
  handleMetricTypeChange: (e: any, index: number) => void;
  handleMetricLabelChange: (e: any, index: number) => void;
  handleDeleteMetrics: (e: any, index: number) => void;
}

const MetricsCard: React.FC<MetricsCardProps> = ({
  metricsValue,
  setMetricsValue,
  metricsContent,
  handleAddMetrics,
  handleMetricKeyChange,
  handleMetricTypeChange,
  handleMetricLabelChange,
  handleDeleteMetrics,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Box
      sx={{
        height: "100%",
      }}
    >
      <Box
        sx={{
          ...styles.container,
          display: "flex",
          alignItems: "end",
          justifyContent: "space-between",
        }}
      >
        <FormControl sx={styles.switchFormControl}>
          <FormLabel
            sx={{
              color: theme.palette.text.primary,
              "&.Mui-focused": {
                color: theme.palette.text.primary,
              },
            }}
          >
            Métricas
          </FormLabel>
          <FormControlLabel
            value="bottom"
            control={
              <Switch
                sx={{
                  marginLeft: -1,
                }}
                checked={metricsValue}
                onChange={(e) => setMetricsValue(e.target.checked)}
              />
            }
            label="Adiciona legenda customizável"
            labelPlacement="top"
            sx={styles.switchLabel}
          />
        </FormControl>
        {metricsValue && (
          <Button
            sx={{ color: theme.palette.primary.main }}
            startIcon={<Add />}
            onClick={handleAddMetrics}
          >
            Adicionar
          </Button>
        )}
      </Box>
      {metricsValue &&
        metricsContent?.length > 0 &&
        metricsContent.map((metric, index) => (
          <Box sx={{ display: "flex", gap: 1 }} key={index}>
            <TextField
              sx={styles.textField}
              label="Nome da coluna"
              placeholder="Digite o nome da coluna"
              variant="filled"
              value={metric.key || ""}
              onChange={(e) => handleMetricKeyChange(e, index)}
            />
            <TextField
              value={metric.type}
              sx={styles.textField}
              label="Tipo"
              variant="filled"
              select
              onChange={(e) => handleMetricTypeChange(e, index)}
              fullWidth
            >
              <MenuItem value={"avg"}>Media</MenuItem>
              <MenuItem value={"sum"}>Somatorio</MenuItem>
              <MenuItem value={"max"}>Maximo</MenuItem>
              <MenuItem value={"min"}>Minimo</MenuItem>
            </TextField>
            <TextField
              sx={styles.textField}
              label="Label"
              variant="filled"
              value={metric.label}
              onChange={(e) => handleMetricLabelChange(e, index)}
            />
            <IconButton
              sx={{ color: theme.palette.cromatic.red.main }}
              onClick={(e) => handleDeleteMetrics(e, index)}
            >
              <GridDeleteIcon />
            </IconButton>
          </Box>
        ))}
      <Divider />
    </Box>
  );
};

export default React.memo(MetricsCard);
